<template lang="pug">
  v-timeline(align-top, dense)
    v-timeline-item(color="teal accent-3", icon="edit")
      v-row.pt-1
        v-col
          strong {{ getWITADate(item.ipDate) }} - {{ item.ipStatus == 1 ? 'Drafted by' : 'Submited by' }} {{ item.ipUser.name }} ({{ item.ipUser.title }} ) as Creator

    //- <!-- Handle 'Visitor' status for BIB-HSE-PPO-IZIN-TAMU -->
    v-timeline-item(
      v-if="item.ipVisitorStatus",
      :icon="config.status[item.ipVisitorStatus].icon",
      :color="config.status[item.ipVisitorStatus].color"
    )
      v-row.pt-1
        v-col
          strong Submitted Visitor

    //- <!-- Handle workflows based on formType -->
    v-timeline-item(
      v-for="(workflow, index) in item.ipWorkflow",
      :key="workflow.date",
      :color="config.status[workflow.status].color",
      :icon="config.status[workflow.status].icon"
    )
      v-row.pt-1(
        v-if="workflow.status == 7 || workflow.status == 8"
      )
        v-col
          strong(v-if="workflow.admin_reject == true") {{ getWITADate(workflow.date) }} - {{ config.status[workflow.status].name }} by {{ workflow.admin_detail.name }} ({{ workflow.admin_detail.title }}) as Admin
          strong(v-else) {{ getWITADate(workflow.date) }} - {{ config.status[workflow.status].name }} by {{ getNameApproverKTT(workflow) }} 
            span(v-if="workflow.matrix.includes('KTT')") (Kepala Teknik Tambang) 
            span(v-else-if="workflow.postAs == 'waskat'") ({{ workflow.postAs == "waskat" ? "HSE" : workflow.postAs == "karyawan" ? "Teknisi" : workflow.postAs == "atasan" ? "Lead" : workflow.postAs == "secHead" ? "Lead" : "Lead" }}) 
            span(v-else) ({{ getTitleApprover(workflow) }}) 
            span as {{ timelineDetail(workflow.postAs, index) }}
          .caption.mb-2 {{ workflow.comment }}
      v-row.pt-1(v-else)
        v-col
          strong {{ workflow.status == 9 ? 'Need Approval by ' : '' }}{{ timelineDetail(workflow.postAs, index, formType) }}

    //- <!-- Handle "Close" status -->
    v-timeline-item(
      v-if="item.ipVisitorStatus", 
      :icon="item.ipStatus == 12 && dayjs().isAfter(dayjs(item.ipSelesaiKunjungan)) ? 'check' : ''",
      :color="item.ipStatus == 12 && dayjs().isAfter(dayjs(item.ipSelesaiKunjungan)) ? 'blue' : 'grey'"
    )
      v-row.pt-1
        v-col
          strong Close

    //- <!-- Handle the different closing workflows based on the formType and statuses -->
    v-timeline-item(
      v-if="item.ipPengesahan",
      :icon="item.ipStatus == 10 || item.ipStatus == 11 || item.ipStatus == 12 ? 'fact_check' : ''",
      :color="item.ipStatus == 10 || item.ipStatus == 11 || item.ipStatus == 12 ? 'teal accent-3' : 'grey'"
    )
      v-row.pt-1(
        v-if="item.ipStatus == 10 || item.ipStatus == 11 || item.ipStatus == 12"
      )
        v-col
          strong {{ item.ipPengesahan ? getWITADate(item.ipPengesahan.ipClosingSubmitted) : getWITADate(item.ipClosingDate) }} - Closing Submited by {{ item.ipUser.name }} ({{ item.ipUser.title }} ) as Creator
      v-row.pt-1(v-else)
        v-col
          strong Closing Submited

    v-timeline-item(
      v-else-if="!item.ipVisitorStatus",
      :icon="item.ipStatus == 10 || item.ipStatus == 11 || item.ipStatus == 12 ? 'fact_check' : ''",
      :color="item.ipStatus == 10 || item.ipStatus == 11 || item.ipStatus == 12 ? 'teal accent-3' : 'grey'"
    )
      v-row.pt-1(
        v-if="item.ipStatus == 10 || item.ipStatus == 11 || item.ipStatus == 12"
      )
        v-col
          strong {{ getWITADate(item.ipClosingDate) }} - Closed by {{ item.ipUser.name }} ({{ item.ipUser.title }} ) as Creator
      v-row.pt-1(v-else)
        v-col
          strong Close

    v-timeline-item(
      v-if="item.ipPengesahan",
      :icon="item.ipPengesahan && item.ipStatus == 12 ? 'fact_check' : ''",
      :color="item.ipPengesahan && item.ipStatus == 12 ? 'teal accent-3' : 'grey'"
    )
      v-row.pt-1(v-if="item.ipPengesahan && item.ipStatus == 12")
        v-col
          strong {{ getWITADate(item.ipClosingDate) }} - Closed by {{ item.ipPengesahan.ipWorkflow[0].name }} ({{ item.ipPengesahan.ipWorkflow[0].title }} ) as {{ item.ipPengesahan.ipWorkflow[0].matrix[0] || 'PNC' }}
      v-row.pt-1(v-else)
        v-col
          strong Close
</template>

<script>
export default {
  name: "TimelineItems",
  props: {
    item: Object,
    config: Object,
    getWITADate: Function,
    timelineDetail: Function,
    getNameApproverKTT: Function,
    getTitleApprover: Function,
    formType: String,
  },
};
</script>
